import currentUserSelector from './currentUserSelector'

const currentUserIdSelector = () => {
  const user = currentUserSelector()

  return user?.id
}

export default currentUserIdSelector
